export default ({
	EN: {
		progressStates: [
			'Account',
			'Contact',
			'Location',
			'Schedule',
			'Review'
		],
		progressMeterDisplay: (index, steps) => `Step ${index + 1} of ${steps.length}`
	},
	ES: {
		progressStates: [
			'Cuenta',
			'Contacto',
			'Ubicacíon',
			'Programar',
			'Revisíon'
		],
		progressMeterDisplay: (index, steps) => `Paso ${index + 1} de ${steps.length}`
	}
});
